import { Redirect } from "react-router-dom"
import { useAppContext } from "../app-context/use-app-context"
import { useAuthUser } from "../users/hooks/use-auth-user"
import { useUrlWithContext } from "../hooks/use-url-with-context"
import { paths } from "../paths"

const RedirectToHome = () => {
  const { appContext } = useAppContext()
  const { mainContext } = appContext
  const { user } = useAuthUser()
  const { createPathWithContext, createPathWithGivenContext } = useUrlWithContext()

  if (!user) return <p>Loading user...</p>
  if (user.isDeactivated) {
    const deactivatedPath = createPathWithGivenContext({ path: paths.deactivated(), mainContextId: user.id })
    return <Redirect to={deactivatedPath} />
  }
  if (user.isWaitingVerification) {
    const accountVerificationPath = createPathWithGivenContext({
      path: paths.accountVerification(),
      mainContextId: user.id,
    })
    return <Redirect to={accountVerificationPath} />
  }
  if (!mainContext) return <p>Main context is not detected, can't redirect</p>
  const to = createPathWithContext(paths.home(), { withSubContext: true })
  return <Redirect to={to} />
}

export default RedirectToHome
